exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-transport-check-box>>>.v-input__control{height:25px}.service-transport-check-box.v-input--selection-controls.v-input .v-label{white-space:nowrap;margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42215562","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/services/ServiceTransportForm.vue
// module id = 1w2z
// module chunks = 0